import qs from 'qs'
import { axios } from '@/utils/request'

const api = {
  getVerificationCode: '/api/1/device/get_verification_code.json',
  expertLogin: '/api/1/device/expert_login.json',
  getVerificationCodeByExpertLogin: '/api/1/device/get_verification_code_expert_login',
  getVerificationCodeByExpertEditPhone: '/api/1/device/get_verification_code_expert_edit_phone',
  weChatLogin: '/api/1/device/weChat/login',
  weChatCallback: '/api/1/device/weChat/callback',
  weChatBindMobilePhone: '/api/1/device/weChat/bind_mobile_phone',
  weChatRebindOpenId: '/api/1/device/weChat/rebind_open_id'
}

/**
 *  获取登录验证码
 * @param mobile
 * @returns {AxiosPromise<any>}
 */
export const GetVerificationCode = (mobile) => axios.get(api.getVerificationCode, { params: { mobile } })

/**
 *  专家登录
 * @param loginDto
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const ExpertLogin = (loginDto) => axios.post(api.expertLogin, qs.stringify(loginDto))

/**
 *  专家登录获取登录验证码并校验
 * @param mobile
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetVerificationCodeByExpertLogin = (mobile) => axios.get(api.getVerificationCodeByExpertLogin, { params: { mobile } })

/**
 *  专家修改手机号码时获取验证码并校验
 * @param mobile
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetVerificationCodeByExpertEditPhone = (mobile) => axios.get(api.getVerificationCodeByExpertEditPhone, { params: { mobile } })

/**
 *  微信登录获取地址
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const WeChatLogin = () => axios.get(api.weChatLogin)

/**
 *  微信登录获取地址
 * @param weChatLoginDto 登录参数 {code}
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const WeChatCallback = (weChatLoginDto) => axios.post(api.weChatCallback, qs.stringify(weChatLoginDto))

/**
 *  微信网页授权绑定手机号码
 * @param bindData {mobilePhone,openId}
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const WeChatBindMobilePhone = (bindData) => axios.post(api.weChatBindMobilePhone, qs.stringify(bindData))
/**
 *  微信网页授权重新绑定微信号
 * @param bindData {mobilePhone,openId}
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const WeChatRebindOpenId = (bindData) => axios.post(api.weChatRebindOpenId, qs.stringify(bindData))
